import { useHistory, useParams, useRouteMatch } from 'quartz-routing/react-router';
import { SEARCH_QUERY_KEY } from './components/PlaylistItemSearchManager';
import { PLAYLIST_RESULTS_URL_FRAGMENT } from '../../constants/Navigation';
import { useIsPartner } from '../partners';
import { useMemo } from 'react';
import { PLAYLIST_SEARCH_RESULTS_SIZE } from './playlistItemsConsts';
import { useCatalogSearchResults } from '../search/searchHooks';
export const usePlaylistSearchManagerOpenState = playlistId => {
  const history = useHistory();
  const {
    path
  } = useRouteMatch();
  const isPlaylistSearchManagerOpen = path === PLAYLIST_RESULTS_URL_FRAGMENT;
  const {
    playlistId: paramPlaylistId
  } = useParams();
  const openPlaylistSearchManager = searchTerm => {
    const pId = playlistId || paramPlaylistId;
    if (!pId) return;
    const search = new URLSearchParams(history.location.search);
    if (searchTerm) search.set(SEARCH_QUERY_KEY, searchTerm);
    history.push(Object.assign({}, history.location, {
      pathname: PLAYLIST_RESULTS_URL_FRAGMENT.replace(':playlistId', pId.toString()),
      search: search.toString()
    }));
  };
  return {
    isPlaylistSearchManagerOpen,
    openPlaylistSearchManager
  };
};
export const isUnrestrictedPlaylistItem = ({
  visibility
}, isPartner) => (isPartner || visibility !== 'PARTNER') && visibility !== 'IN_TRACK_ONLY';

// extracts items from the playlist that cannot be visualised (track only items, partner, ...)
export const useFilteredRestrictedPlaylistItems = playlistItems => {
  const isPartner = useIsPartner();
  return useMemo(() => (playlistItems === null || playlistItems === void 0 ? void 0 : playlistItems.filter(item => isUnrestrictedPlaylistItem(item, isPartner))) || null, [isPartner, playlistItems]);
};
export const usePlaylistItemsSearch = ({
  skip
} = {}) => useCatalogSearchResults({
  pageSize: PLAYLIST_SEARCH_RESULTS_SIZE,
  contentTypes: ['TRACK', 'LESSON', 'SHORT_FORM_CONTENT'],
  skip
});